<template>
  <main>
    <div class="container-fluid message page-note">
      <TopTemplate>
        <template #left-element>
          <div>
            <h3>{{ $t("common.bulletinsListe") }}</h3>
            <p class="mb-0">{{ titleBulletin }}</p>
          </div>
        </template>
        <template v-slot:right-element>
          <div class="d-flex">
            <router-link :to="{name: 'BulletinNotes'}" class="btn btn-outline-primary button margin-r" :disabled="loading">
              <i class="arrow left"></i>
              {{ $t("button.retour") }}
            </router-link>
            <div v-if="disableActionBtn" class="spinner-border text-info spinner-bulletin" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <button v-if="disableBtnCommunicate" class="btn button btn-primary" @click="communicateToParents" :disabled="loading || disableActionBtn">
              {{ $t("common.communicateToParents") }}
            </button>
          </div>
        </template>
      </TopTemplate>
      <nav class="mb-2">
        <div class="nav nav-tabs list-nav-pay" id="nav-tab" role="tablist">
          <button
            v-for="(tab, index) in tabs"
            :key="index"
            class="nav-link"
            :class="{active: currentTab === tab.id}"
            :id="'nav-' + tab.id + '-tab'"
            data-bs-toggle="tab"
            :data-bs-target="'#nav-' + tab.id"
            type="button"
            role="tab"
            :aria-controls="'nav-' + tab.id"
            :aria-selected="currentTab === tab.id"
            @click="changeTab(tab.id, tab.period)"
          >
            {{ tab.label }}
          </button>
        </div>
        <div class="content-tabs">
          <!-- <div v-for="(tab, index) in tabs" :key="index" class="tab-pane fade" :class="{active: currentTab === tab.id}" :id="'nav-' + tab.id" role="tabpanel"></div> -->
        </div>
      </nav>

      <div class="search-date-wrapper search-Bulletin mb-2 mt-3">
        <div class="col-md-12 search">
          <input v-model="param.q" type="text" placeholder="Recherche" name="search" @input="searshClasse()" />
          <img src="../../assets/icons/search-icon.svg" class="icon-search" alt="search" />
        </div>
      </div>

      <div v-if="loading" class="card mt-2 text-center d-block pt-2 pb-24">
        <div class="spinner-border text-info" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>

      <div class="table teacher table-note bulletin-list" v-if="!loading && bulletinList.length > 0">
        <div class>
          <div class="row">
            <div class="col-md-12">
              <div class="table__wrapper table-responsive-vertical table-responsive">
                <table class="table">
                  <thead>
                    <tr class="row">
                      <th class="col-md-4">{{ $t("eleve.tab.name") }}</th>
                      <th class="col-md-4 text-center">{{ $t("common.moyenneGeneral") }}</th>
                      <th class="col-md-4 view pr-0">{{ $t("common.action") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(ele, index) in bulletinList" :key="ele.id + 'class'" class="row" :class="{'odd-row': isOddRow(index)}">
                      <td class="col-md-4">
                        <p class="classe-title">{{ ele.student_full_name }}</p>
                      </td>
                      <td class="col-md-4 text-center">
                        <p>{{ ele.student_average }}</p>
                      </td>
                      <td class="col-md-4 action style-picto pr-0">
                        <div class="block-action">
                          <a class="success_msg name_propre" :class="{disabled: disabledOpen[index]}" @click="handleBulletinAction(ele, 'open', index)">
                            <i class="icon-eyes green-color">
                              <span class="tooltiptext">{{ $t("button.tooltip.details") }}</span>
                            </i>
                          </a>
                          <a class="success_msg name_propre" :class="{disabled: disabledPrint[index]}" @click="handleBulletinAction(ele, 'print', index)">
                            <i class="icon-eyes ri-printer-line green-color">
                              <span class="tooltiptext">{{ $t("button.tooltip.printer") }}</span>
                            </i>
                          </a>
                          <a class="success_msg name_propre" :class="{disabled: disabledDownload[index]}" @click="handleBulletinAction(ele, 'download', index)">
                            <i class="icon-eyes ri-download-line green-color">
                              <span class="tooltiptext">{{ $t("button.tooltip.download") }}</span>
                            </i>
                          </a>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="!loading && !bulletinList.length" class="block-no-data">
        <p>{{ $t("common.noBulletinsGenerated") }}</p>
      </div>
      <iframe ref="pdfViewer" :src="pdfUrl" style="width: 100%; height: 600px; display: none"></iframe>
    </div>
  </main>
</template>

<script>
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import NoteService from "../../services/note.service";
import vSelect from "vue-select";

export default {
  components: {
    TopTemplate,
    "v-select": vSelect,
  },
  setup() {
    return {};
  },
  data() {
    return {
      loading: false,
      bulletinList: [],
      currentTab: "trimestre1",
      tabs: Array.from({length: 3}, (_, i) => ({
        id: `trimestre${i + 1}`,
        label: `Trimestre ${i + 1}`,
        period: i + 1,
      })),
      id: null,
      param: {
        q: "",
      },
      periodId: 1,
      disabledDownload: [],
      disabledPrint: [],
      disabledOpen: [],
      pdfUrl: "",
      disableActionBtn: false,
      classObject: {
        class_name: "",
        school_year: "",
        period: "",
      },
    };
  },
  computed: {
    titleBulletin() {
      const {class_name, school_year, period} = this.classObject;
      return `${class_name} - ${school_year} - ${period}`;
    },
    disableBtnCommunicate() {
      return this.classObject.school_year_status;
    },
  },
  mounted() {
    this.id = this.$route.params.id;
    this.getBulletinList(this.id, this.periodId);
  },
  methods: {
    changeTab(tabId, period) {
      this.currentTab = tabId;
      this.periodId = period;
      this.getBulletinList(this.id, period);
    },
    async communicateToParents() {
      this.disableActionBtn = true;
      const Swal = require("sweetalert2");
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-confirm  btn-primary",
          cancelButton: "btn  btn-cancel  btn-outline-primary",
        },
        buttonsStyling: false,
        showCloseButton: true,
      });
      try {
        const data = {
          period_id: this.periodId,
          school_year: this.bulletinList.length && this.bulletinList[0].school_session_id,
        };
        const result = await swalWithBootstrapButtons.fire({
          title: this.$t("common.confirmCommunicateBulletin"),
          icon: "info",
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonText: this.$t("common.deletIT"),
          cancelButtonText: this.$t("common.noCancel"),
          reverseButtons: true,
        });
        if (result.isConfirmed) {
          await NoteService.communicateToParents(this.id, data);
        }
      } catch (err) {
        console.error("error : ", err);
      } finally {
        this.disableActionBtn = false;
      }
    },
    async getBulletinList(id, period_id) {
      try {
        this.loading = true;
        const config = {
          params: {
            q: this.param.q,
            class_id: id,
            period_id: period_id,
            // school_session_id: 3,
          },
        };
        const res = await NoteService.getBulletinList(config);
        this.bulletinList = res.data.data;
        this.classObject = res.data;
      } catch (err) {
        console.error("error : ", err);
      } finally {
        this.loading = false;
      }
    },
    async handleBulletinAction(file, actionType, index) {
      const config = {
        responseType: "arraybuffer",
      };
      switch (actionType) {
        case "open":
          this.disabledOpen[index] = true;
          break;
        case "print":
          this.disabledPrint[index] = true;
          break;
        case "download":
          this.disabledDownload[index] = true;
          break;
      }
      try {
        const res = await NoteService.downloadBulletinPdf(file.report_url, config);
        const blob = new Blob([res.data], {type: "application/pdf"});
        const url = URL.createObjectURL(blob);

        switch (actionType) {
          case "print":
            this.pdfUrl = url;
            this.$refs.pdfViewer.onload = () => {
              this.$refs.pdfViewer.contentWindow.print();
              URL.revokeObjectURL(url);
            };
            break;
          case "download":
            const link = document.createElement("a");
            link.href = url;
            link.download = `bulletin_${file.period}_${file.class_name}`;
            link.click();
            URL.revokeObjectURL(url);
            break;
          case "open":
            const newTab = window.open(url, "_blank");
            if (newTab) {
              newTab.focus();
            }
            URL.revokeObjectURL(url);
            break;
        }
      } catch (err) {
        console.error("error : ", err);
      } finally {
        switch (actionType) {
          case "open":
            this.disabledOpen[index] = false;
            break;
          case "print":
            this.disabledPrint[index] = false;
            break;
          case "download":
            this.disabledDownload[index] = false;
            break;
        }
      }
    },
    isOddRow(index) {
      return index % 2 == 0;
    },
    searshClasse: _.debounce(function () {
      if (this.param.q.toString().length > 1 || !this.param.q.toString().length) {
        this.getBulletinList(this.id, this.periodId);
      }
    }, 200),
  },
};
</script>

<style lang="scss" scoped>
.disabled {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
}
.spinner-bulletin {
  height: 20px;
  margin-top: 8px;
  width: 20px;
  margin-right: 4px;
}
</style>
